import React, { useEffect, useState } from "react";
import { HomeLayout } from "./Home.styles";
import MuiButton from "../../atoms/Buttons/Button.component";
import RoundLogo from "../../atoms/LogoHome/LogoHome.component";

export const Home: React.FC = () => {
  const [countdown, setCountdown] = useState(20);

  const redirectToSnow = async () => {
    window.location.replace(process.env.REACT_APP_SNOW_URL);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          redirectToSnow();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <HomeLayout>
      <RoundLogo />
      <h1>MAG portal has been decommissioned</h1>
      <p>
        Following initial migration plan the MAG Portal has been decommissioned
        as of December 15, 2025.
        <br />
        To continue submitting requests, please use ServiceNow. Click the button
        below to be redirected.
      </p>
      <MuiButton onClick={redirectToSnow}>Go to ServiceNow</MuiButton>
      <br />
      <p>Automatic redirect to ServiceNow in {countdown} seconds...</p>
    </HomeLayout>
  );
};
export default Home;
